var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* no local variables */
__p+='\n<div class="alert alert-dark alert-dismissible alert-notify alert-fixed-bottom-right" role="alert" id="save-listing-error-alert">\n    <button id="save-listing-error-alert-dismiss" type="button" class="close" aria-label="Close">\n      <span aria-hidden="true">×</span>\n    </button>\n  <span>You\'ve been so busy. But you\'ve reached the maximum number listings you can save. Please delete some of the listings to add more.</span>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/saving_over_limit_warning.jst.ejs